import ThirdPartyAdmin from 'components/ThirdPartyAdmin';
import { Field, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import ReactSelect from "react-select";
import { Option, LimitedChipsContainer } from 'components/Options';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactInputMask from "react-input-mask";
import Calendar from "assets/icon/calendar-icon.svg";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";
import FormikInputField from 'components/common/Fields/FormikInputField';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import RxManager from '..';
import * as Yup from "yup";
import moment from 'moment';
import { dateFormate } from 'utils/columns';
import { cloneDeep } from 'lodash';

const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required(
    "Third Party Administrator is required"
  ),
});
let hasDatePopupOpen = false;
let ceData = [];
let pharmacyData = [];
let claimTypesData = [];
let prescriptionError = "";

const SearchContainer = (props) => {
  const API = useAxios();
  const {
    states: { rxManager },
    setStates,
    resetStates,
  } = useContextService();

  const [isSubmited, setIsSubmitted] = useState(false);
  const [date,setDate]= useState(null);
  const [loading, setLoading] = useState(false);
  const [hasCESelected, setCESelected] = useState(true);
  const [claimTypesList, setClaimTypes] = useState([]);
  const [showClaimList, setShowClaims] = useState([]);
  const [selectedOpt, setOptSelected] = useState({ optSelected: "-1" });
  const [selectedOption, setOptionSelected] = useState({optionSelected: "-1"});
  const [selectedClaimType, setClaimTypeSelected] = useState();
  const [selectedshowClaim, setShowClaimSelected] = useState();
  const [ceDatalist, setCeDatalist] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [rxnum, setrxnum] = useState("");
  const { onSearch, onReset} = props;
  const { thirdPartyAdmin,searchTerms,coveredEntity,pharmacy} = rxManager;
  const {thirdPartyAdminID, coveredEntityIDs,coveredEntityID,showClaimID,startDate,endDate,pharmacyIds,claimTypeId,ceIds} = searchTerms;
  const { tenantID } = thirdPartyAdmin;
  const[startDate1, setStartDate1]=useState(null);
  const[endDate1, setEndDate1] = useState(null);

  const updateStates = (rxManager) => {
    setStates("rxManager", rxManager);
  };

  useEffect(() => {
    fetchClaimTypes();
  }, []);

  useEffect(() => {
    setOptSelected({ optionSelected: "-1" });
    setOptionSelected({ optionPhSelected: "-1" });
    setClaimTypeSelected("");
    rxManager.thirdPartyAdminID ="";
    rxManager.thirdPartyAdmin = {};
    rxManager.searchTerms.startDate = "";
    rxManager.searchTerms.endDate = "";
    rxManager.searchTerms.rxNumber = "";
    rxManager.searchTerms.claimTypeId = "";
    rxManager.searchTerms.pharmacyIds = {};
    rxManager.searchTerms.coveredEntityIDs = {};
    updateStates(rxManager);
    resetStates("rxManager");
    setrxnum("");
    prescriptionError = "";
  },[]);


  const fetchClaimTypes = async () => {
    try {
      const { data } = await API.get("GWConfig/TypeStatus/ClaimTypes", {
        hasDefaultURL: true,
      });
      if (data) {
        claimTypesData = data;
        if (claimTypeId) {
          rxManager.searchTerms.claimStatusId = claimTypeId;
          updateStates(rxManager);
        }
        setClaimTypes(data);
      } else {
        setClaimTypes([]);
      }
    } catch (error) { }
  };

  
  const handleSubmit = async (val, actions) => {
    setIsSubmitted(true);
    const { setSubmitting } = actions;
    let coveredEntityIDS = [];
    let pharmacyIDs = [];

    for (var x in selectedOption.optionSelected) {
      var rw = selectedOption.optionSelected[x];
      coveredEntityIDS.push(rw.value);
    }

    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x];
      pharmacyIDs.push(rw.value);
    }

    const values = cloneDeep(val);
    if (thirdPartyAdminID) values.thirdPartyAdminID;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;
    else{
      values.coveredEntityIDS = [];
    }
    if (pharmacyIDs > [0]) { values.pharmacyIDS = pharmacyIDs; }
    else {
      values.pharmacyIDS = [];
    }

    if (startDate) values.startDate = moment(startDate).format('MM/DD/YYYY');
    if (endDate) values.endDate = moment(endDate).format('MM/DD/YYYY');
    if (showClaimID) {
      values.showClaimID = showClaimID;
      setSubmit(true);
    }
    values.claimTypeId = claimTypeId;
    values.rxNumber = rxnum;
    values.claimStatusId = selectedClaimType;
    rxManager.search.currentPage = 1;
    if (rxnum.length == 1 || rxnum.length == 2) {
      prescriptionError = "Please Enter Atleast 3 Characters";
    } else {
      prescriptionError = "";
      updateStates(rxManager);
      await onSearch(values);
      setSubmitting(false);
    }
  };

  const handleClaimTypeChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue("claimTypeId", value);
    setClaimTypeSelected(value);
    rxManager.searchTerms.claimTypeId = value;
    updateStates(rxManager);
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleOnChange = (e, setFieldValue) => {
    const { value } = e.target;
    if(value.length > 2 ){
      prescriptionError = "";
    }
    setFieldValue("rxNumber", value);
    setrxnum(value);
    rxManager.searchTerms.rxNumber = value;
    updateStates(rxManager);
  };

  const handleStartDate = (startDate) => {
    setStartDate1(startDate);
    rxManager.searchTerms.startDate = startDate;
    updateStates(rxManager);
  };

  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && rxManager.searchTerms.startDate !== null && val == "__/__/____") {
      rxManager.searchTerms.startDate = null;
      setStartDate1(null);
      updateStates(rxManager);
    }
    if (isValid) {
      const newDate = new Date(e.target.value);
      handleStartDate(e.target.value);
    }
  };

  const handleEndDate = (endDate) => {
    setEndDate1(endDate);
    rxManager.searchTerms.endDate = endDate;
    updateStates(rxManager);
  };

  const handleEndDateRaw = (e) => {
    var Valdt = new Date(startDate);
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && rxManager.searchTerms.endDate !== null && val == "__/__/____") {
      rxManager.searchTerms.endDate = null;
      setEndDate1(null);
      updateStates(rxManager);
    }

    if (isValid && val >= Valdt) {
      handleEndDate(e.target.value);
    }
  };

  const handleReset = ({ resetForm }) => {
    setIsSubmitted(false);
    setClaimTypeSelected("");
    setrxnum("");
    window.selectedCoveredEntittyId = "";
    resetForm();
    onReset();
    setOptSelected({ optSelected: "-1" });
    setOptionSelected({ optionSelected: "-1" });
    rxManager.searchTerms.coveredEntityIDs = {};
    rxManager.searchTerms.ceIds = {};
    rxManager.searchTerms.pharmacyIds = {};
    updateStates(rxManager);
    setOptSelected({ optSelected: "-1" });
    resetStates("rxManager");
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    setStartDate1(null);
    setEndDate1(null);
    prescriptionError = "";
  };
 

  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    setOptSelected({ optSelected: "-1" });
    setOptionSelected({ optionSelected: "-1" });
    rxManager.searchTerms.coveredEntityIDs = {};
    rxManager.searchTerms.ceIds = {};
    rxManager.searchTerms.pharmacyIds = {};
    const { thirdPartyAdminID } = tpa;
    rxManager.searchTerms.pharmacyIds = {};
    setOptSelected({ optSelected: "-1" });
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    fetchCoveredEntities(thirdPartyAdminID);
    fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    if (tpa) {
      const { thirdPartyAdminID } = tpa;
      setFieldValue("thirdPartyAdminID", value);
      rxManager.coveredEntity = "";
      rxManager.searchTerms.coveredEntityID = "";
      rxManager.pharmacy = "";
      rxManager.searchTerms.pharmacyID = "";
      rxManager.thirdPartyAdmin = tpa;
      rxManager.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
    } else {
      setFieldValue("thirdPartyAdminID", "");
      rxManager.coveredEntity = "";
      rxManager.searchTerms.coveredEntityID = "";
      rxManager.pharmacy = "";
      rxManager.searchTerms.pharmacyID = "";
      rxManager.thirdPartyAdmin = {};
      rxManager.searchTerms.thirdPartyAdminID = "";
      pharmacyData = [];
      ceData = [];
    }
    updateStates(rxManager);
  };

  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          ceData.push({ value: data[x].id, label: data[x].description });
        }
        setCeDatalist(ceData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchPharmacyNamesByTpaID = async (thirdPartyAdminID) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/GetPharmaciesByTpaId/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchPharmacyNames = async (selected) => {
    let payloads = [];
    pharmacyData = [];
    for (var x in selected) {
      var rw = selected[x];
      payloads.push(rw.value);
    }
    let payload = {};
    payload.CoveredIDS = payloads;
    try {
      const { data } = await API.post(
        `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      console.log(data);
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };


  const handleCEChange = (selected) => {
    if (selected.length !== 0) {
      setOptSelected({
        optSelected: -1,
      });
    }
    if (selected.length === 0) {
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    }
    pharmacyData = [];
    setOptionSelected({
      optionSelected: selected,
    });
    rxManager.searchTerms.ceIds = selected;
    updateStates(rxManager);
    fetchPharmacyNames(selected);
  };

  const handlepharmacyChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    rxManager.searchTerms.pharmacyids = selected;
    updateStates(rxManager);
  };

  return (
    <div>
      <Formik
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      initialValues={searchTerms}
      children={(props) => {
        const {isSubmitting,handleSubmit,resetForm,setFieldValue,errors,touched} = props;
        return (
          <div>
            <h5 className="f-16 text-primary font-weight-700">
            Search Rx Manager
            </h5>
            <Row>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <ThirdPartyAdmin
                    value={thirdPartyAdminID}
                    name="thirdPartyAdminID"
                    onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value, setFieldValue, tpa)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
              <FormGroup>
                  <Label for="coveredEntity">Covered Entity</Label>
                  <ReactSelect
                    name="ceDatalist"
                    options={ceDatalist}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handleCEChange}
                    value={selectedOption.optionSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="pharmacyname">Pharmacy</Label>
                  <ReactSelect
                    name="pharmacyData"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlepharmacyChange}
                    value={selectedOpt.optSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={6}>
                <FormGroup>
                  <Label for="claimType">Claim Type</Label>
                  <Field
                    name="claimType"
                    type="text"
                    value={selectedClaimType}
                    onChange={(e) => handleClaimTypeChange(e, setFieldValue)}
                    component={FormikSelectField}
                    options={claimTypesData}
                    show={true}
                    defaultoption="--All--"
                    keys={{
                      id: "id",
                      label: "description",
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
            <Col md={3} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="rxNumber">Prescription #</Label>
                  <Input
                    id="rxNumber"
                    name="rxNumber"
                    type="text"
                    value={rxnum}
                    onChange={(e) => handleOnChange(e, setFieldValue)}
                    placeholder="Enter 3 to 12 characters"
                    autoComplete="off"
                    component={FormikInputField}
                    maxLength={12}
                  // onKeyUp={(e) => handleOnChange(e)}
                  />
                  {
                    prescriptionError != ""
                      ? (
                        <div className="text-danger f-12 position-absolute">
                          {prescriptionError}
                        </div>
                      ) : null}
                </FormGroup>
              </Col>

              <Col md={3} sm={6}>
                <Row>
                  <Col className="purchase-date">
                    <FormGroup>
                      <Label>Start Date</Label>
                      <InputGroup onMouseLeave={handleMouseLeave}>
											<DatePicker
												id='startDate'
												name='startDate'
												selected={startDate1}
												onChange={(e) => { handleStartDate(e) }}
												onChangeRaw={handleStartDateRaw}
												dateFormat="MM/dd/yyyy"

												placeholderText='Select a date'
												autoComplete='off'
												customInput={
													<ReactInputMask mask="99/99/9999"
														value={startDate1}
													// maskChar=''
													/>
												}
											/>
											<InputGroupText
												onClick={() => handleDateClick('startDate')}
											>
												<img src={Calendar} alt='' />
											</InputGroupText>

										</InputGroup>
                    </FormGroup>
                  </Col>
                  <Col xs="auto" className="pt-3 mt-3">
                    <Label className="mt-1">-</Label>
                  </Col>
                  <Col className="purchase-date">
                    <FormGroup>
                      <Label>End Date</Label>
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <DatePicker
                          id="endDate"
                          name="endDate"
                          selected={endDate1}
                          onChange={(e) => {
                            handleEndDate(e);
                          }}
                          onChangeRaw={handleEndDateRaw}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Select a date"
                          autoComplete="off"
                          minDate={new Date(startDate1)}
                          customInput={
                            <ReactInputMask mask="99/99/9999" value={endDate1} />
                          }
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("endDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="d-flex" style={{ justifyContent: "flex-end" }}>
              <Col md="auto" className="">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search"
                >
                  <span className="right_5">
                  <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button color="primary"
                  className="reset"
                  onClick={() => handleReset(props)}
                >
                  <span className="right_5">
                  <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>

            </Row>
          </div>
        );
      }}
    ></Formik>
    </div>
  )
}
export default SearchContainer